// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"683bd828","121":"6112aa24","848":"6112aa24","875":"410a9991"}[chunkId] + ".chunk.css";
};